import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import './style.module.scss';

class NotFound extends PureComponent {
  componentDidMount() {
    const { wemediaId, realUserId } = this.props.common.user
    window.antReport("首页", wemediaId, 'pv', realUserId);
  }

  render() {
    return <div styleName="not-found">
    <div styleName="s-icon" />
    <div styleName="s-text">新版网易号开放平台已上线</div>
    <div>
      <button styleName="s-btn" onClick={() => window.open('/subscribe_v3/index.html')}>立即前往</button>
    </div>
  </div>
  }
}

export default connect(
  state => ({
    common: state.common,
  }),
)(NotFound);
